import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {SpecialitesService} from '../../services/specialites/specialites.service';

@Component({
  selector: 'app-home-specialitati',
  templateUrl: './home-specialitati.component.html',
  styleUrls: ['./home-specialitati.component.scss']
})
export class HomeSpecialitatiComponent implements OnInit {

    specialties: any;

    constructor(
        private specialtiesService: SpecialitesService
    ) {
        this.loadItems();
    }

    categoriesSlides: OwlOptions = {
    loop: true,
    nav: true,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    margin: 30,
    navText: [
        '<i class=\'bx bx-left-arrow-alt\'></i>',
        '<i class=\'bx bx-right-arrow-alt\'></i>'
    ],
    responsive: {
        0: {
        items: 1
        },
        576: {
        items: 2
        },
        768: {
        items: 3
        },
        1200: {
        items: 4
        }
    }
    };

    loadItems() {
        const t = this;
        this.specialtiesService.get().subscribe((data: any) => {
            t.specialties = data;
            t.sortItems();
        });
    }

    sortItems() {
        const t = this;
        for (let i = 0; i < t.specialties.length; i++) {
            if ( t.specialties[i].active === false) {
                t.specialties.splice(i, 1);
                i--;
            }
        }
    }

    ngOnInit(): void {
    }

}
